var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainScanPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.9999C1 14.3431 2.34311 13 3.99991 13H7.9998C9.6566 13 10.9997 14.3431 10.9997 15.9999V19.9998C10.9997 21.6566 9.6566 22.9997 7.9998 22.9997H3.99991C2.34311 22.9997 1 21.6566 1 19.9998V15.9999ZM3.99991 14.9999C3.44764 14.9999 2.99994 15.4476 2.99994 15.9999V19.9998C2.99994 20.5521 3.44764 20.9998 3.99991 20.9998H7.9998C8.55206 20.9998 8.99977 20.5521 8.99977 19.9998V15.9999C8.99977 15.4476 8.55206 14.9999 7.9998 14.9999H3.99991Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 18C6.99976 17.4477 6.55205 17 5.99979 17V17C5.44752 17 4.99981 17.4477 4.99981 18V18C4.99981 18.5522 5.44752 18.9999 5.99979 18.9999V18.9999C6.55205 18.9999 6.99976 18.5522 6.99976 18V18Z",
    fill: "#007AFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3.99991C1 2.34311 2.34311 1 3.99991 1H7.9998C9.6566 1 10.9997 2.34311 10.9997 3.99991V7.9998C10.9997 9.6566 9.6566 10.9997 7.9998 10.9997H3.99991C2.34311 10.9997 1 9.6566 1 7.9998V3.99991ZM3.99991 2.99994C3.44764 2.99994 2.99994 3.44764 2.99994 3.99991V7.9998C2.99994 8.55206 3.44764 8.99977 3.99991 8.99977H7.9998C8.55206 8.99977 8.99977 8.55206 8.99977 7.9998V3.99991C8.99977 3.44764 8.55206 2.99994 7.9998 2.99994H3.99991Z",
    fill: "#007AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99976 5.99997C6.99976 5.4477 6.55205 5 5.99979 5V5C5.44752 5 4.99981 5.4477 4.99981 5.99997V5.99997C4.99981 6.55224 5.44752 6.99994 5.99979 6.99994V6.99994C6.55205 6.99994 6.99976 6.55224 6.99976 5.99997V5.99997Z",
    fill: "#007AFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9995 15.9999C12.9995 14.3431 14.3426 13 15.9994 13H19.9993C21.6561 13 22.9992 14.3431 22.9992 15.9999V19.9998C22.9992 21.6566 21.6561 22.9997 19.9993 22.9997H15.9994C14.3426 22.9997 12.9995 21.6566 12.9995 19.9998V15.9999ZM15.9994 14.9999C15.4472 14.9999 14.9995 15.4476 14.9995 15.9999V19.9998C14.9995 20.5521 15.4472 20.9998 15.9994 20.9998H19.9993C20.5516 20.9998 20.9993 20.5521 20.9993 19.9998V15.9999C20.9993 15.4476 20.5516 14.9999 19.9993 14.9999H15.9994Z",
    fill: "#33DAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9994 18C18.9994 17.4477 18.5517 17 17.9994 17C17.4472 17 16.9994 17.4477 16.9994 18C16.9994 18.5522 17.4472 18.9999 17.9994 18.9999C18.5517 18.9999 18.9994 18.5522 18.9994 18Z",
    fill: "#33DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9995 8.99957C20.5517 8.99957 20.9994 8.55187 20.9994 7.9996L20.9994 3.99972L22.9994 3.99972L22.9994 7.9996C22.9994 9.65641 21.6563 10.9995 19.9995 10.9995L15.9996 10.9995L15.9996 8.99957L19.9995 8.99957Z",
    fill: "#007AFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9995 4.00055L14.9995 6.00049L12.9995 6.00049L12.9995 4.00055C12.9995 2.34374 14.3426 1.00063 15.9994 1.00063L17.9994 1.00063L17.9994 3.00058L15.9994 3.00058C15.4472 3.00058 14.9995 3.44828 14.9995 4.00055Z",
    fill: "#007AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainScanPayment);
export default __webpack_public_path__ + "static/media/main-scan-payment.c8d3e2666df7d1719b72f31f378660a6.svg";
export { ForwardRef as ReactComponent };